import * as React from "react"

import Hero from '../components/hero'
import LandingPageHistory from '../components/LandingPages/history'
import LandingPageCallUs from '../components/LandingPages/callUs'
import Testimonials from '../components/testimonial'
import PhoneCTA from '../components/phoneCTA'
import PhotoGallery from '../components/photoGallery'
import Section from '../components/sectionWrapper'
import ContactUs from '../components/ContactUs'
import Header from '../components/Header'
import Footer from '../components/Footer'

import { Seo } from "../components/seo"
import { historyText, callUsText } from '../constants';

// styles
const pageStyles = {
  color: "#232129",
  fontFamily: "-apple-system, Roboto, sans-serif, serif",
}

// markup
const HaddonTownshipNJPage = () => {
  return (
    <main style={pageStyles}>
      <Header />
      <Section shadedBG hero>
        <Hero></Hero>
      </Section>
      <Section>
        <LandingPageCallUs callUsText={callUsText.haddonTownship}></LandingPageCallUs>
      </Section>
      <Section shadedBG className='smallSection'>
        <PhoneCTA></PhoneCTA>
      </Section>
      <Section>
        <LandingPageHistory historyText={historyText.haddonTownship}></LandingPageHistory>
      </Section>
      <Section shadedBG className='testimonialSection'>
        <Testimonials></Testimonials>
      </Section>
      <Section>
        <PhotoGallery></PhotoGallery>
      </Section>
      <Section shadedBG contactForm>
        <ContactUs></ContactUs>
      </Section>
      <Footer />
    </main>
  )
}

export default HaddonTownshipNJPage;

export const Head = () => <Seo />;
